<div class="modal-body">
	<button class="close" (click)="closeAndDestroy()">
		<i class="fa-light fa-xmark"></i>
	</button>
	<div class="delivery-item">
		<div>
			<h3>PRODUCTION TIMES</h3>

			<div class="production-times">
				@for (productionTime of productionTimes; track productionTime.name) {
					<p>
						<span class="font-medium">{{ productionTime.name }}</span>
						{{ productionTime.time }}
					</p>
				}
			</div>

			<p class="notes-heading">Please keep the following points in mind</p>

			<ul>
				@for (note of productionTimeNotes; track note) {
					<li>{{ note }}</li>
				}
			</ul>
		</div>
	</div>
</div>
